import * as t from "io-ts";

export const ObjectMeterCheckAssocValidator = t.intersection([
  t.type({
    id: t.string,
    meterId: t.string,
    objectId: t.string,
    objectType: t.string,
  }),
  t.partial({
    meterName: t.string,
    objectName: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const ObjectMeterCheckAssocArrayValidator = t.array(ObjectMeterCheckAssocValidator);

export type ObjectMeterCheckAssoc = t.TypeOf<typeof ObjectMeterCheckAssocValidator>;
export type ObjectMeterCheckAssocArray = t.TypeOf<typeof ObjectMeterCheckAssocArrayValidator>;
